module.exports = __webpack_public_path__ + "img/image3.2cae863b.png";